import { Injectable } from "@angular/core";
import {
    RemovePostInputType,
    RemovePostUsecase
} from "@arch/domain/application/usecase/remove-post.usecase";

@Injectable({
    providedIn: "root"
})
export class RemovePostController {
    constructor(private readonly removePostUsecase: RemovePostUsecase) {}

    public async execute(input: RemovePostInputType): Promise<boolean> {
        return this.removePostUsecase.execute(input);
    }
}
